const TRACE_KEY = '__tripvioModuleTraceT0';

export function traceModuleEvaluation(moduleId: string): void {
  if (!__DEV__ && process.env.EXPO_PUBLIC_UI_DEBUG_LOGS !== 'true') {
    return;
  }

  const traceScope = globalThis as typeof globalThis & {
    [TRACE_KEY]?: number;
  };

  if (typeof traceScope[TRACE_KEY] !== 'number') {
    traceScope[TRACE_KEY] = Date.now();
  }

  console.warn(`[module_eval] ${moduleId} t=${Date.now() - traceScope[TRACE_KEY]}ms`);
}
